var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");Object.defineProperty(exports,"__esModule",{value:true});exports.tentEngineFactory=exports.loadShakaPlayerEngine=void 0;var _regenerator=_interopRequireDefault(require("@babel/runtime/regenerator"));var loadShakaPlayerEngine=function loadShakaPlayerEngine(){var _require,ShakaPlayerEngine;return _regenerator.default.async(function loadShakaPlayerEngine$(_context){while(1)switch(_context.prev=_context.next){case 0:_require=


require('@24i/player-shaka-player'),ShakaPlayerEngine=_require.ShakaPlayerEngine;return _context.abrupt("return",
ShakaPlayerEngine);case 2:case"end":return _context.stop();}},null,null,null,Promise);};exports.loadShakaPlayerEngine=loadShakaPlayerEngine;


var tentEngineFactory=function tentEngineFactory(){var config,ShakaPlayerEngine;return _regenerator.default.async(function tentEngineFactory$(_context2){while(1)switch(_context2.prev=_context2.next){case 0:
config={
streaming:{
preferNativeHls:true
}
};_context2.next=3;return _regenerator.default.awrap(

loadShakaPlayerEngine());case 3:ShakaPlayerEngine=_context2.sent;return _context2.abrupt("return",
new ShakaPlayerEngine(config));case 5:case"end":return _context2.stop();}},null,null,null,Promise);};exports.tentEngineFactory=tentEngineFactory;